/* Store-specific presentation; native Shopify radio inputs remain authoritative. */
(() => {
  const source = document.querySelector('script[data-gg-option-assets]');
  if (!source) return;
  const sweater = ['beige','white','rose pink','khaki','dusty blue','orange','green','black','navy','light pink','red','light purple','mint','mustard'];
  const fabric = ['gingham red','gingham pink','gingham yellow','gingham green','gingham mint','gingham baby blue','gingham purple','gingham taupe','gingham brown','gingham black'];
  const normalize = value => value.toLowerCase().replace(/^\s*\d+[.\s-]*/, '').trim();
  function thumbnail(input) {
    const group = input.name.toLowerCase(), name = normalize(input.value);
    let index, x, y, width, height, src;
    if (group === 'color sweater' && (index = sweater.indexOf(name)) >= 0) {
      x = index < 12 ? [138,313,487,660][index % 4] : [313,487][index - 12];
      y = index < 12 ? [195,351,505][Math.floor(index / 4)] : 660;
      width = height = 397; x /= 2; y /= 2; src = source.dataset.sweater;
    } else if (group === 'color fabric' && (index = fabric.indexOf(name)) >= 0) {
      x = [70,185,299,414,528][index % 5] * .6;
      y = (index < 5 ? 236 : 420) * .6;
      width = 359.4; height = 327; src = source.dataset.fabric;
    } else return null;
    const box = document.createElement('span'); box.className = 'gg-option-image';
    const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = width; img.height = height;
    img.style.cssText = `width:${width}px;height:${height}px;left:${38-x}px;top:${32-y}px`; box.append(img); return box;
  }
  const closeOthers = current => document.querySelectorAll('details.gg-option-picker[open]').forEach(el => { if (el !== current) el.open = false; });
  function sync(fieldset) {
    const details=fieldset.querySelector('.gg-option-picker');
    const input=fieldset.querySelector('input:checked');
    if(!details || !input)return;
    const summary=details.querySelector('summary');
    summary.querySelector('.gg-option-image')?.remove();
    const image=thumbnail(input);if(image)summary.prepend(image);
    summary.querySelector('.gg-option-selected').textContent=input.value;
    summary.setAttribute('aria-label',`${input.name}: ${input.value}`);
  }
  function enhance() {
    document.querySelectorAll('variant-selects fieldset').forEach(fieldset => {
      // This product template uses visible native option buttons.
      if (fieldset.closest('[id^="MainProduct-"]')?.querySelector('.gg-ns-intro')) {
        const picker = fieldset.closest('variant-selects');
        const sizeInputs=[...fieldset.querySelectorAll('input[type="radio"]')];
        if(sizeInputs.length&&/size/i.test(sizeInputs[0].name))sizeInputs.forEach(input=>{
          const value=input.value.toLowerCase(),number=parseInt(value,10);
          const rank=/newborn/.test(value)?-1:/\d+t\b/.test(value)?number*12:Number.isNaN(number)?999:number;
          input.closest('.product-form__item').style.order=rank;
        });
        const palette = {'beige':'#e8d8b6','white':'#f2f0eb','rose pink':'#ca8097','khaki':'#ab8d7a','dusty blue':'#84afc4','orange':'#ef8b18','green':'#60977c','black':'#202020','navy':'#24324d','light pink':'#efb2bf','red':'#b21638','light purple':'#ba99d4','mint':'#83d8bb','mustard':'#d7a13b'};
        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
          const label=fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if(!label)return;
          if(/color sweater|sweater color/i.test(input.name)){
            const color=palette[normalize(input.value).replace(/ sweater$/,'')];
            if(color){label.classList.add('gg-solid-color');label.style.setProperty('--gg-option-color',color);}
            label.querySelectorAll('.variant__btn__text,.btn__texts span').forEach(el=>{const clean=el.textContent.replace(/^\s*\d+\.\s*/,'');if(el.textContent!==clean)el.textContent=clean;});
          }
          if(input.name==='Color Fabric'&&!label.querySelector('.gg-option-image')){const image=thumbnail(input);if(image)label.prepend(image);}
        });
        if (fieldset.querySelector('input[name="Applique Fabric Pattern"]')) {
          fieldset.querySelectorAll('.variant__btn__text, .variants-label__value').forEach(el => {
            const clean = el.textContent.replace(/^\s*\d+\.\s*/, '');
            if (el.textContent !== clean) el.textContent = clean;
          });
        }
        if (new URL(location.href).searchParams.get('view') === 'name-sweater-preview') {
          picker.dataset.updateUrl = 'false';
          picker.getProductInfo = async function () {
            const url = new URL(this.dataset.url, location.origin);
            url.searchParams.set('variant', this.variant_id);
            url.searchParams.set('section_id', this.dataset.originalSection || this.dataset.section);
            url.searchParams.set('view', 'name-sweater-preview');
            const response = await fetch(url);
            this.new_html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const selector = 'variant-selects script[type="application/json"]';
            this.newJSON = this.new_html.querySelector(selector).textContent;
            const script = this.querySelector(selector);
            if (script) script.textContent = this.newJSON;
          };
        }
        return;
      }
      if (fieldset.querySelector('.gg-option-picker')) {sync(fieldset);return;}
      const inputs = [...fieldset.querySelectorAll('input[type="radio"]')];
      if (inputs.length < 2) return;
      const container = fieldset.querySelector('.product-form__container');
      if (!container) return;
      const details = document.createElement('details'); details.className = 'gg-option-picker';
      const summary = document.createElement('summary'); summary.className = 'gg-option-trigger';
      const selected = inputs.find(i => i.checked);
      const image = selected && thumbnail(selected); if (image) summary.append(image);
      const text = document.createElement('span'); text.className = 'gg-option-selected'; text.textContent = selected ? selected.value : `Choose ${inputs[0].name.toLowerCase()}`; summary.append(text);
      const arrow = document.createElement('span'); arrow.className = 'gg-option-arrow'; arrow.setAttribute('aria-hidden','true'); summary.append(arrow);
      summary.setAttribute('aria-label', `${inputs[0].name}: ${text.textContent}`);
      summary.setAttribute('aria-expanded','false'); details.append(summary);
      container.classList.add('gg-option-list'); container.removeAttribute('style');
      if (/size sweater/i.test(inputs[0].name)) {
        [...container.children].sort((a,b) => {
          const rank = el => { const v = el.querySelector('input').value.toLowerCase(); const n = parseInt(v,10); return Number.isNaN(n) ? 999 : /\bt\b|\d+t/.test(v) ? n*12 : n; };
          return rank(a)-rank(b);
        }).forEach((row,index) => row.style.order=index);
      } else if (/color sweater/i.test(inputs[0].name)) {
        [...container.children].sort((a,b)=>parseInt(a.querySelector('input').value,10)-parseInt(b.querySelector('input').value,10)).forEach((row,index)=>row.style.order=index);
      }
      inputs.forEach(input => {
        const label = container.querySelector(`label[for="${CSS.escape(input.id)}"]`); if (!label) return;
        label.className = 'gg-option-row'; label.replaceChildren();
        const image = thumbnail(input); if (image) label.append(image);
        const name = document.createElement('span'); name.textContent = input.value; name.className='gg-option-name'; label.append(name);
        const check = document.createElement('span'); check.className='gg-option-check'; check.textContent='✓'; check.setAttribute('aria-hidden','true'); label.append(check);
      });
      container.before(details); details.append(container);
      details.addEventListener('toggle',()=>{summary.setAttribute('aria-expanded',String(details.open));if(details.open)closeOthers(details);});
      summary.addEventListener('click',()=>{if(!details.open)closeOthers(details);});
      details.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();details.open=false;summary.focus();}});
    });
  }
  let queued=false;
  const observer=new MutationObserver(()=>{if(queued)return;queued=true;queueMicrotask(()=>{queued=false;observer.disconnect();enhance();observe();});});
  const observe=()=>document.querySelectorAll('variant-selects').forEach(el=>observer.observe(el,{childList:true,subtree:true}));
  enhance();observe();
  document.addEventListener('change',event=>{const fieldset=event.target.closest('variant-selects fieldset');if(!fieldset)return;sync(fieldset);const details=fieldset.querySelector('.gg-option-picker');if(details)details.open=false;});
  document.addEventListener('click',event=>document.querySelectorAll('details.gg-option-picker[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;}));
  document.addEventListener('shopify:section:load',()=>{enhance();observe();});
})();

// Validate the two distinct personalization fields on this alternate template.
document.addEventListener('click', function (event) {
  const button = event.target.closest('button[name="add"]');
  if (!button) return;
  const section = button.closest('[id^="MainProduct-"]');
  const initial = section?.querySelector('[id^="GGInitial-"]');
  const name = section?.querySelector('[id^="GGSmallName-"]');
  if (!initial || !name) return;
  const noApplique = section.querySelector('input[name="Applique Fabric Pattern"]:checked')?.value === 'No Applique';
  if (noApplique) { event.preventDefault(); event.stopImmediatePropagation(); initial.setCustomValidity('Please choose a gingham fabric above.'); initial.reportValidity(); return; }
  initial.setCustomValidity(!noApplique && !initial.value.trim() ? 'Please enter the large fabric letter.' : '');
  name.setCustomValidity(!name.value.trim() ? 'Please enter the small embroidered name.' : '');
  const invalid = !initial.checkValidity() ? initial : !name.checkValidity() ? name : null;
  if (invalid) {
    event.preventDefault();
    event.stopImmediatePropagation();
    invalid.reportValidity();
    invalid.focus();
  }
}, true);
document.addEventListener('input', function (event) {
  if (event.target.matches('[id^="GGInitial-"], [id^="GGSmallName-"]')) event.target.setCustomValidity('');
});

// Keep required personalization valid on all clothing preview products.
document.addEventListener('click', function(event) {
  const button = event.target.closest('button[name="add"]');
  const section = button?.closest('[id^="MainProduct-"]');
  if (!section?.querySelector('.gg-ns-intro')) return;
  const optionalCustom=section.querySelector('input[value="No Custom"]');
  const customName=section.querySelector('[id^="GGName-"]');
  if(optionalCustom&&customName)customName.required=!optionalCustom.checked;
  const fields = section.querySelectorAll('.gg-ns-personalization input[required]');
  for (const field of fields) {
    if (field.value.trim() && field.checkValidity()) continue;
    event.preventDefault(); event.stopImmediatePropagation();
    field.reportValidity(); field.focus(); return;
  }
}, true);
